<template>
    <div class="codics-aonaer-info-sys-user-left-tab-body">
        <div class="codics-aonaer-info-sys-user-left-tab-info-box" :data-content="userInfo?.user?.nickname"
            @click="jumpToPage('个人信息', {}, {})">
            <el-image class="codics-aonaer-info-sys-user-left-tab-info-himg"
                :src="userInfo?.user?.himg == null ? 'https://cdn.bosscaigou.com/huayuan/img/yasuo_60bc7e65a6d385d503656e12772d226.webp' : ('https://cdn.bosscaigou.com/' + userInfo?.user?.himg)"
                fit="fill"></el-image>
        </div>
        <div class="codics-aonaer-info-sys-user-left-tab-points-box" :data-points="userInfo?.user?.points?.points || 0">
            <div class="codics-aonaer-info-sys-user-left-tab-points-box-shop" @click="jumpToPage('积分商城', {}, {})">积分商城
            </div>
        </div>
        <div class="codics-aonaer-info-sys-user-left-tab-tag-box">
            <div class="codics-aonaer-info-sys-user-left-tab-tag-item iconfont" v-for="(item, index) in tagData"
                :key="index" v-html="item" @click="menuClick(index)">
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { jumpTo } from '@/utils/myutils';
export default {
    data() {
        return {
            tagData: ['&#xe6b6;  系统首页', '&#xe7b7;  订单记录', '&#xe76e;  积分记录', '&#xe6c0;  积分榜单', '&#xe862;  退出登录']
        }
    },
    methods: {
        menuClick(idx) {
            switch (idx) {
                case 0:

                    jumpTo(this, "系统首页", {}, {});

                    break;
                case 1:
                    jumpTo(this, "兑换记录", {}, {});
                    break;
                case 2:
                    jumpTo(this, "积分记录", {}, {});
                    break;
                case 3:
                    let date = new Date();
                    window.location = window.location.origin + '/list/' + date.getFullYear() + '/' + (date.getMonth() + 1);
                    break;
                case 4:
                    this.$store.dispatch('logout');
                    jumpTo(this, "系统首页", {}, {});
                    break;
            }
        },
        jumpToPage(n, p, q) {

            jumpTo(this, n, p, q);

        }
    },
    computed: {
        ...mapState(['userInfo'])
    },
}
</script>

<style>
.codics-aonaer-info-sys-user-left-tab-body {
    height: 100%;
    min-height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    background: #FFF;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-user-left-tab-info-box {
    height: 180px;
    width: 100%;
    position: relative;
    float: left;
    border-bottom: 1px solid #f7f7f7;
    cursor: pointer;
}

.codics-aonaer-info-sys-user-left-tab-info-box::after {
    content: attr(data-content);
    height: 24px;
    position: absolute;
    margin: auto;
    top: 110px;
    left: 0;
    right: 0;
    bottom: 0;
    line-height: 24px;
    text-align: center;
    font-size: 16px;
    color: #333;
}

.codics-aonaer-info-sys-user-left-tab-info-himg {
    height: 86px;
    width: 86px;
    position: absolute !important;
    margin: auto;
    top: -30px;
    left: 0;
    right: 0;
    bottom: 0;
    box-sizing: border-box;
    border-radius: 50%;
    border: 1px solid #f7f7f7;
}

.codics-aonaer-info-sys-user-left-tab-points-box {
    height: 120px;
    width: 100%;
    position: relative;
    float: left;
    border-bottom: 1px solid #f7f7f7;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-user-left-tab-points-box::before,
.codics-aonaer-info-sys-user-left-tab-points-box::after {
    height: 36px;
    width: fit-content;
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    padding: 0 30px;
    line-height: 36px;
    color: #333;
    font-size: 20px;
}

.codics-aonaer-info-sys-user-left-tab-points-box::before {
    content: attr(data-points);
    font-size: 32px !important;
    font-family: "dinpro";
    color: #ea5b18 !important;
    top: -20px;
    font-weight: bold;
}

.codics-aonaer-info-sys-user-left-tab-points-box::after {
    content: '我的积分';
    color: #777;
    font-size: 14px;
    line-height: 22px;
    top: 50px;
}

.codics-aonaer-info-sys-user-left-tab-points-box-shop {
    height: 36px;
    width: fit-content;
    position: absolute;
    margin: auto;
    top: 0;
    right: 20px;
    bottom: 0;
    padding: 0 20px;
    border-radius: 20px;
    text-align: center;
    font-size: 14px;
    color: #ea5b18;
    border: 1px solid #ea5b18;
    transition: .3s;
    line-height: 34px;
    box-sizing: border-box;
    cursor: pointer;
    user-select: none;
    -webkit-user-drag: none;
}

.codics-aonaer-info-sys-user-left-tab-points-box-shop:hover {
    background: #ea5b18;
    color: #FFF;
}

.codics-aonaer-info-sys-user-left-tab-tag-box {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 20px 30px;
}

.codics-aonaer-info-sys-user-left-tab-tag-item {
    height: 43px;
    width: 100%;
    position: relative;
    float: left;
    line-height: 43px;
    font-size: 15px;
    color: #333;
    cursor: pointer;
    transition: .3s;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-user-left-tab-tag-item:hover {
    background: rgba(0, 0, 0, .15);
    color: #ea5b18;
    padding-left: 20px;
}
</style>